import React from 'react';
import Switch from 'shared/components/switch/Switch';
import { includeFieldRows } from 'components/campaigns/CampaignConstants';
import useStore from '../../hooks/useCampaignStore';

const IncludeAvailsFields = (props) => {
  const { includeAvails, setIncludeAvails } = props;
  const { isCampaignActive, setIsFormTouched } = useStore((state) => state);

  const handleOnIncludeAvailChange = (name, value) => {
    setIsFormTouched(true);
    setIncludeAvails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  return (
    <>
      <div className="d-flex flex-column gap-10 align-items-center">
        <div className="w-100 border-bottom d-flex gap-2">
          <span>Include Avails</span>
        </div>
      </div>
      <div className="include-avail-fields">
        {includeFieldRows.map((field, index) => (
          <div
            className={`gap-2 include-avails-field-column ${
              index < 2
                ? 'include-avails-field-column-1'
                : 'include-avails-field-column-2'
            }`}
          >
            <span>{field.label}</span>
            <div style={{ fontSize: '1rem' }}>
              <Switch
                active={includeAvails[field.name]}
                disabled={!isCampaignActive}
                onSwitch={(val) => handleOnIncludeAvailChange(field.name, val)}
              />
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default IncludeAvailsFields;
